module.exports = __webpack_public_path__ + "assets/img/NPC016.554a30ca.png";